import React from 'react'
import { StyleSheet } from 'react-native'
import { Spacing, Text, TextProps } from 'zens-storybook'
import { useBuilding, useLocation } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    marginTop: Spacing.XS,
  },
})

interface Props extends TextProps {
  value: number
  companyId: number
}
const BuildingField = (props: Props) => {
  const { value: buildingId, companyId, style, ...otherProps } = props
  const building = useBuilding({ companyId, buildingId })
  const location = useLocation({
    companyId,
    locationId: building?.data?.locationId || NaN,
  })
  return (
    <Text level={6} style={[styles.container, style]} {...otherProps}>
      {location.data?.name}, {building.data?.name}
    </Text>
  )
}

export default BuildingField
